import { BadgeStyle, DisplayFormat, FetchStatus, Property, PropertyType } from "../../../../base/types";
import { IAsyncBoundProperties, usePropertyDraftText } from "../../../../base/hooks";
import { useEffect, useState } from "react";

import { IBadgeProps } from "./IBadgeProps";
import { formatValue } from "../../../helpers";

export const BadgeProperties = [
    { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
    { id: Property.Text, name: 'Text', type: PropertyType.String },
    { id: Property.Format, name: 'Format', type: PropertyType.DisplayFormat },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.BackgroundStyle, name: 'Style', type: PropertyType.BadgeStyle },
    { id: Property.RoundedPill, name: 'Rounded-Pill', type: PropertyType.Boolean },
]

export const useBadgeProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IBadgeProps>()
    const draftText = usePropertyDraftText({ bindings, property: Property.Text })

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const textValue = bindings.getValue<string>(Property.Text);
        const format = bindings.getValue<DisplayFormat>(Property.Format);
        const text = formatValue(textValue, format)
        const title = bindings.getValue<string>(Property.Tooltip);
        const icon = bindings.getValue<string>(Property.MaterialIcon);
        const style = bindings.getValue<BadgeStyle>(Property.BackgroundStyle);
        const roundedPill = bindings.getValue<boolean>(Property.RoundedPill);

        setProperties({ text, title, icon, badgeStyle: style as any, roundedPill })
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties, draftText }
}
